import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import "core-js/modules/es6.string.small";
import _Map from "@babel/runtime-corejs2/core-js/map";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import styled from 'styled-components';
import { enhanceWithTrackable } from '../hocs';
import { Ripple } from '../Ripple';
import { Spinner } from '../Spinner';
import { propTypes } from './Button.types';
import { ButtonPrimaryGreySkin, ButtonPrimaryGreyReverseSkin, ButtonPrimaryRedSkin, ButtonPrimaryRedReverseSkin, ButtonSecondaryGreySkin, ButtonSecondaryGreyReverseSkin, ButtonSecondaryRedSkin, ButtonSecondaryRedReverseSkin } from './skins';
var skinMap = new _Map();
skinMap.set('primarygrey', ButtonPrimaryGreySkin);
skinMap.set('primarygreyreverse', ButtonPrimaryGreyReverseSkin);
skinMap.set('primaryred', ButtonPrimaryRedSkin);
skinMap.set('primaryredreverse', ButtonPrimaryRedReverseSkin);
skinMap.set('secondarygrey', ButtonSecondaryGreySkin);
skinMap.set('secondarygreyreverse', ButtonSecondaryGreyReverseSkin);
skinMap.set('secondaryred', ButtonSecondaryRedSkin);
skinMap.set('secondaryredreverse', ButtonSecondaryRedReverseSkin);
export var getSkin = function getSkin(_ref) {
  var kind = _ref.kind,
      color = _ref.color,
      reverseColor = _ref.reverseColor;
  var key = kind + color + (reverseColor ? 'reverse' : '');
  var map = skinMap.get(key);
  return map;
};
export var getSpinnerColor = function getSpinnerColor(_ref2) {
  var color = _ref2.color,
      kind = _ref2.kind,
      reverseColor = _ref2.reverseColor;

  if (reverseColor || kind === 'secondary') {
    return color;
  }

  return 'white';
};
var ButtonText = styled.span.withConfig({
  displayName: "Button__ButtonText",
  componentId: "sc-17097tx-0"
})(["opacity:", ";"], function (props) {
  return props.spinner ? 0 : 1;
});
var SpinnerHolder = styled.div.withConfig({
  displayName: "Button__SpinnerHolder",
  componentId: "sc-17097tx-1"
})(["position:absolute;top:0;right:0;left:0;bottom:0;display:flex;justify-content:center;align-items:center;"]);

var Button = function Button(_a) {
  var block = _a.block,
      color = _a.color,
      disabled = _a.disabled,
      kind = _a.kind,
      reverseColor = _a.reverseColor,
      small = _a.small,
      spinner = _a.spinner,
      text = _a.text,
      rest = __rest(_a, ["block", "color", "disabled", "kind", "reverseColor", "small", "spinner", "text"]);

  var ButtonElement = getSkin({
    kind: kind,
    color: color,
    reverseColor: reverseColor
  });
  var spinnerColor = getSpinnerColor({
    kind: kind,
    color: color,
    reverseColor: reverseColor
  });
  var width = block ? '100%' : 'auto';
  var isDisabled = disabled || spinner;
  return React.createElement(Ripple, {
    width: width,
    render: function render(_ref3) {
      var onBlur = _ref3.onBlur,
          onFocus = _ref3.onFocus,
          onKeyDown = _ref3.onKeyDown,
          onMouseDown = _ref3.onMouseDown,
          onMouseLeave = _ref3.onMouseLeave,
          onMouseUp = _ref3.onMouseUp,
          onTouchEnd = _ref3.onTouchEnd,
          onTouchMove = _ref3.onTouchMove,
          onTouchStart = _ref3.onTouchStart;
      return React.createElement(ButtonElement, _extends({}, rest, {
        disabled: isDisabled,
        spinner: spinner,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyDown,
        onMouseDown: onMouseDown,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart,
        block: block,
        small: small
      }), React.createElement(ButtonText, {
        spinner: spinner
      }, text), spinner && React.createElement(SpinnerHolder, null, React.createElement(Spinner, {
        color: spinnerColor,
        size: "sm",
        show: true
      })));
    }
  });
};

Button.propTypes = propTypes;
Button.displayName = 'button';
Button.defaultProps = {
  block: false,
  color: 'red',
  'data-id': Button.displayName,
  kind: 'primary',
  accessibilityExpanded: false,
  accessibilityHaspopup: false,
  disabled: false,
  autoFocus: false,
  type: 'button',
  reverseColor: false,
  spinner: false,
  small: false
};
var TrackableButton = enhanceWithTrackable(Button);
export { TrackableButton as Button };